import { createStore } from 'vuex';


const store = createStore({
  state: {
    user: null,
    business: null
  },
  mutations: {
    setUser(state, newUser) {
      state.user = newUser;
    },
    setBusiness(state, newBusiness) {
      state.business = newBusiness;
    },
  },
  actions: {
    saveUser({ commit }, newUser) {
      commit('setUser', newUser);
    },
    saveBusiness({ commit }, newBusiness) {
      commit('setBusiness', newBusiness);
    }
  },
  getters: {
    getUser(state) {
      return state.user;
    },
    getBusiness(state) {
      return state.business;
    },
  }
})

export default store